import React from 'react';
import { PageBody } from '../core/components/page/PageBody';
import { EmployeePageWrapper } from './EmployeePageWrapper';

export const EmployeeErrorPage = ({ breadcrumbLabel, children }) => (
    <EmployeePageWrapper breadcrumbs={[<span key="1">{breadcrumbLabel}</span>]}>
        <PageBody>{children}</PageBody>
    </EmployeePageWrapper>
);
